import React, { useEffect, useRef, useState } from "react";
import "./Dashboardpage.scss";
import ClockSvg from "@Assets/svg/Dashboard-svgs/clock.svg";
import NoMocktestSvg from "@Assets/svg/Dashboard-svgs/NoMocktest.svg";
import { CardDashboardIndex, SkeletonCardDashboardIndex } from "./Components/Cards";
import { RecommendedPracticeSlider } from "./Components/RecommendedPracticeSlider/RecommendedPracticeSlider";

import { getDashboardTestSeriesDetails, getDashboarddetails, getPopularTests, getAvgDurations, getadviceoryTestSeries, getBalanceTests } from "../Service/Dashboard.service";
import { useSubscriptionNavigation } from '@Src/hooks/useSubscriptionNavigation';
import { NoSubscriptionDialog } from '@Components/NoSubscriptionDialog/NoSubscriptionDialog';
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { error } from "console";
import { useAppSelector } from "@Src/app/hooks";
import { useUserDisplayName } from "@Src/utils/userDisplayName";

import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';


import SvgIcon from "@Components/icons/SvgIcon";
import { TabView, TabPanel } from 'primereact/tabview';
import { useNavigate } from 'react-router-dom';
import { AppRouteURL, DetailsRouteURL } from "@Constants/app-route-url.constant";
import AddBannerImg from "@Assets/img/add-banner.jpg";
import { Tooltip } from 'react-tooltip';
import Dropdown from "@Components/DropDown/DropDown";
import { Chart } from 'primereact/chart';
import { VideoTutorials } from "@Src/features/Home/components/VideoTutorials/VideoTutorials";
import { getUserDetails } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Dialog } from "primereact/dialog";
import { getUserTestPerformance } from "../services/Dashboard.service";
const colors = ["#9af8ff", "#e88e8e", "#9AD5C0", "#F2E2A0", "#b5f48e", "#C6B7E2", "#7FCAC3", "#F0C28E", "#B5BDC5", "#E4A9C3"]

export const DashboardpageIndex = () => {
  const chartRef = useRef<any>(null);
  const [toggletabs, settoggletabs] = useState(1);
  const [dashdetails, setdashdetails] = useState<any>([]);
  const [dashTestdetails, setdashTestdetails] = useState<any>([]);
  const [dashTestSeriesdetails, setdashTestSeriesdetails] = useState<any>([]);
  const displayName = useUserDisplayName();
  const login = useAppSelector(state => state.login);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [chartData, setChartData] = useState<any>({});
  const [chartOptions, setChartOptions] = useState({});
  const [lineChartData, setLineChartData] = useState({});
  const [lineChartOptions, setLineChartOptions] = useState({});
  const InstituteId = useAppSelector(state => state.login.InstituteId)
  const [statsCompletedCount, setStatsCompletedCount] = useState(0);
  const [statsPendingCount, setStatsPendingCount] = useState(0);
  const [value, setValue] = useState("week");
  const statsTotalCount = statsCompletedCount + statsPendingCount;
  const coursePreferences = useAppSelector(state => state.coursePreferences);
  const { checkSubscriptionAndNavigate, subscriptionDialogProps, pendingTestDialogProps } = useSubscriptionNavigation();
  const [popularTests, setPopularTests] = useState<any[]>([]);
  const [isPopularLoading, setIsPopularLoading] = useState<boolean>(false);
  const [hiddenDatasets, setHiddenDatasets] = useState<any>({});
  const [balanceInfo, setBalanceInfo] = useState<any>({});
  const [performanceInfo, setPerformanceInfo] = useState<any>({});
  const [isBalanceLoading, setIsBalanceLoading] = useState<boolean>(false);
  const [isPerformanceLoading, setIsPerformanceLoading] = useState<boolean>(false);
  const classId = coursePreferences?.classDetails[0]?.Id;
  const boardId = coursePreferences?.boardDetails[0]?.Id;

  const completedList = Array.isArray(dashdetails)
    ? dashdetails.filter((d: any) => Number(d?.IsFinalSubmit) === 1)
    : [];
  const pendingList = Array.isArray(dashdetails)
    ? dashdetails.filter((d: any) => Number(d?.IsFinalSubmit) === 0)
    : [];
  // const dashTestdetails$ = new BehaviorSubject(dashTestdetails),
  //  dashTestSeriesdetails$ = new BehaviorSubject(dashTestSeriesdetails),
  // dashdetails$ = combineLatest([dashTestdetails$, dashTestSeriesdetails$]).pipe(
  //   map(() => {
  //     let appendedData = [...dashTestdetails, ...dashTestSeriesdetails]
  //     return appendedData
  //   }
  //   )
  // );

  const togglebutton = (tabs: any) => {
    settoggletabs(tabs);
  };
  const filteredDashDetails = toggletabs === 1 ? completedList : pendingList;

  const toggleDataset = (index: any) => {
    const chart = chartRef?.current?.getChart();
    if (!chart) return;
    // const meta = chart.getDatasetMeta(index);
    // meta.hidden = meta.hidden === null
    //   ? !chart.data.datasets[index].hidden
    //   : null;

    // chart.update();
    setHiddenDatasets((prev: any) => {
      const nextHidden = !prev[index];

      // Update Chart.js
      chart.setDatasetVisibility(index, !nextHidden);
      chart.update();

      return {
        ...prev,
        [index]: nextHidden
      };
    });
  };

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');



    // Line chart data for performance
    const lineData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: 'Average',
          data: [12, 18, 24, 18, 28, 18, 22, 35, 15, 30, 26, 24],
          fill: false,
          borderColor: documentStyle.getPropertyValue('#2488e0') || '#2488e0',
          tension: 0.4,
          borderWidth: 2,
          pointBackgroundColor: '#2488e0',
          pointBorderColor: '#1169b6',
          pointRadius: 5,
          pointHoverRadius: 7
        },
        {
          label: 'Your performance',
          data: [8, 12, 16, 20, 18, 14, 16, 22, 25, 20, 19, 17],
          fill: false,
          borderColor: documentStyle.getPropertyValue('#e4eef7') || '#e4eef7',
          tension: 0.4,
          borderWidth: 2,
          pointBackgroundColor: '#e4eef7',
          pointBorderColor: '#b3cce3',
          pointRadius: 5,
          pointHoverRadius: 7
        }
      ]
    };
    const lineOptions = {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 1.1,
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            boxWidth: 10,
            boxHeight: 10,
            color: textColor || '#6B7280'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary || '#9CA3AF'
          },
          grid: {
            display: false,
            color: surfaceBorder || '#9CA3AF'
          }
        },
        y: {
          ticks: {
            color: textColorSecondary || '#9CA3AF'
          },
          grid: {
            display: false,
            color: surfaceBorder || '#9CA3AF'
          }
        }
      }
    };

    setLineChartData(lineData);
    setLineChartOptions(lineOptions);
  }, []);

  useEffect(() => {
    dashboarddetails()
    fetchCounts()
    balanceTestsDetails();
    userTestPerformanceDetails();
  }, [])



  function formatDate(dateParam: string) {
    const date = new Date(dateParam);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return [day, month].join('/');
  }
  const formatDay = (date: string) => {
    const now = new Date(date);
    return now.toLocaleDateString("en-US", { weekday: "short" });
  }

  const setChartDataAndOptions = async (value?: string) => {
    try {


      const response = await getAvgDurations({ params: value });
      if (response.ResponseType === 'SUCCESS') {
        const testDates: string[] = [];
        const testSubjects: string[] = [];
        // const myDurations: number[] = [];
        // const allAvgDurations: number[] = [];
        for (let item of response.data.Myavg) {
          // const duration = (Number(item.AvgUsedDuration) / 3600).toFixed(2);
          testDates.push(item.PracticeDate);
          testSubjects.push(item.SubjectName)
          // myDurations.push(Number(duration))
        }

        // for (let item of response.data.Otheravg) {
        //   const duration = (Number(item.AvgUsedDuration) / 3600).toFixed(2);
        //   allAvgDurations.push(Number(duration))
        // }
        const dates = testDates.filter(
          (value, index) => testDates.indexOf(value) === index
        );
        const subjects = testSubjects.filter(
          (value, index) => testSubjects.indexOf(value) === index
        );

        let result: any[] = [];
        for (let s = 0; s < subjects.length; s++) {
          let subjectData = [];
          const data = response.data.Myavg;
          for (let d = 0; d < dates.length; d++) {
            let duration = 0;

            for (let i = 0; i < data.length; i++) {
              if (
                data[i].SubjectName === subjects[s] &&
                data[i].PracticeDate === dates[d]
              ) {
                duration += Number(data[i].UsedDuration);
              }
            }

            subjectData.push((Number(duration) / 3600).toFixed(2));
          }

          result.push({ name: subjects[s], duration: subjectData, index: s });
        }

        const dataset: any[] = [];
        for (let item of result) {
          if (item.name) {
            dataset.push({
              label: `${item.name}`,
              data: item.duration,
              backgroundColor: colors[item.index],
              borderColor: '#5d4bc1',
              borderWidth: 1,
              borderRadius: 20,
              barThickness: 20,
              maxBarThickness: 20,
              stack: 'study'
            })
          }

        }



        let newDates: any = [];
        for (let date of dates) {
          newDates.push(formatDate(date));
        }

        let newDays: any = [];
        for (let date of dates) {
          newDays.push(formatDay(date));
        }

        const data = {
          labels: value === "week" ? newDays : newDates,
          datasets: dataset,
        };

        const options = {
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 1,
          plugins: {
            legend: {
              // labels: {
              //   usePointStyle: true,
              //   boxWidth: 10,
              //   boxHeight: 10,
              // },
              // position: 'top',
              // align: 'start'
              display: false
            },
            tooltip: {
              callbacks: {
                label: function (context: any) {
                  const value = context.raw;
                  const name = context.dataset.label;

                  return `${name} (${value} hours)`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
                ticks: {
                  autoSkip: false
                }
              }
            },
            y: {
              stacked: true,
              beginAtZero: true,
              grid: {
                display: false,
              }
              // display: false
            }
          }

        };

        setChartData(data);
        setChartOptions(options);
      }
    } catch (error) {
      console.log(error);

    }


  }
  useEffect(() => {
    // Bar chart data
    // setChartDataAndOptions(value);
    setHiddenDatasets({});

  }, [value])
  useEffect(() => {
    fetchPopularTests()
  }, [coursePreferences])

  const fetchPopularTests = () => {
    if (!coursePreferences) return;

    const boardId = coursePreferences.boardDetails?.[0]?.Id;
    const classId = coursePreferences.classDetails?.[0]?.Id;
    const LanguageId = login.LanguageId;
    const subjectIds = coursePreferences.subjectDetails?.map((s: any) => s.Id);

    if (boardId && classId && subjectIds) {
      setIsPopularLoading(true);
      getadviceoryTestSeries({
        boardId,
        classId,
        subjectId: subjectIds,
        languageId: [LanguageId],
      }).then((res: APIResponse) => {
        if (res.ResponseType === APIStatus.SUCCESS && res.data?.result) {
          setPopularTests(res.data.result);
        }
        setIsPopularLoading(false);
      }).catch(() => {
        setIsPopularLoading(false);
      });
    }
  };

  const fetchCounts = () => {
    // Fetch completed count
    getDashboardTestSeriesDetails({ page: 1, limit: 1, status: 1, classId, boardId }).then((res: APIResponse) => {
      if (res.ResponseType === APIStatus.SUCCESS && res.data && res.data.length > 0 && res.data[0].total_record !== undefined) {
        setStatsCompletedCount(res.data[0].total_record);
      }
    });
    // Fetch pending count
    getDashboardTestSeriesDetails({ page: 1, limit: 1, status: 0, classId, boardId }).then((res: APIResponse) => {
      if (res.ResponseType === APIStatus.SUCCESS && res.data && res.data.length > 0 && res.data[0].total_record !== undefined) {
        setStatsPendingCount(res.data[0].total_record);
      }
    });
  }
  const balanceTestsDetails = async () => {
    try {
      setIsBalanceLoading(true);
      const response = await getBalanceTests();
      if (response.ResponseType === "SUCCESS") {
        setBalanceInfo(response.data);
      }
      setIsBalanceLoading(false);
    } catch (error) {
      console.log(error);
      setIsBalanceLoading(false);
    }
  }

  const userTestPerformanceDetails = async () => {
    try {
      setIsPerformanceLoading(true);
      const response = await getUserTestPerformance({ classId, boardId });
      if (response.ResponseType === "SUCCESS") {
        setPerformanceInfo(response.data[0]);
      }
      setIsPerformanceLoading(false);
    } catch (error) {
      console.log(error);
      setIsPerformanceLoading(false);
    }
  }

  const dashboarddetails = () => {
    setIsLoading(true)
    // Only use test series API data to avoid duplicates
    dashboardTestSeriesDetails([])
  }

  const dashboardTestSeriesDetails = (testDetails: any) => {
    setIsLoading(true)
    Promise.all([
      getDashboardTestSeriesDetails({ limit: 10, status: 1, classId, boardId }),
      getDashboardTestSeriesDetails({ limit: 10, status: 0, classId, boardId })
    ]).then(([resCompleted, resPending]: [APIResponse, APIResponse]) => {
      let allData: any[] = [];

      if (resCompleted.ResponseType === APIStatus.SUCCESS) {
        if (resCompleted.data && resCompleted.data.length > 0 && resCompleted.data[0].result_data) {
          allData = [...allData, ...resCompleted.data[0].result_data];
        } else if (Array.isArray(resCompleted.data)) {
          allData = [...allData, ...resCompleted.data];
        }
      }

      if (resPending.ResponseType === APIStatus.SUCCESS) {
        if (resPending.data && resPending.data.length > 0 && resPending.data[0].result_data) {
          allData = [...allData, ...resPending.data[0].result_data];
        } else if (Array.isArray(resPending.data)) {
          allData = [...allData, ...resPending.data];
        }
      }

      setdashdetails(allData)
      setIsLoading(false)
    }).catch((error: any) => {
      setIsLoading(false)
      console.log(error)
    })

  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDate = new Date(balanceInfo.EndDate);
  endDate.setHours(0, 0, 0, 0);


  return (
    <>
      <div className="dashboard-page-container ">
        <div className="dash-header">
          {isLoading || isBalanceLoading || isPerformanceLoading ? (
            <div className="mb-4">
              <Skeleton width="20rem" height="2rem" className="mb-2"></Skeleton>
              <Skeleton width="15rem" height="1.2rem"></Skeleton>
            </div>
          ) : (
            <>
              <div className="dash-heading mb-2" style={{ textTransform: 'none' }}>Let's improve your score today, {displayName}</div>
              <div className="mb-1 text-puple-300">Start with what matters most today</div>
            </>
          )}
        </div>

        <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-6 mb-4 ">
          <div className="tw-flex flex-column tw-justify-between " style={{ height: "100%" }}>
            {/* Banner Card */}
            {/* <div className="dash-banner">
              <Card className="custom-card tw-text-white py-2">
                <small className="tw-text-xs mb-2">Congratulations</small>
                <h2 className="tw-text-3xl tw-font-bold mb-3 text-white">You Have Successfully Activated Free Access</h2>
                <p className="tw-text-xs mb-3">Students get up to 6 months of complimentary access.</p>
                {!InstituteId &&
                  <button
                    className="ia-btn ia-btn-secondary ia-btn-rounded"
                    onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                  >
                    Subscribe Now <SvgIcon name="rightArrow" size={16} />
                  </button>
                }
              </Card>
            </div> */}
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-pb-2 tw-gap-3">

              {isBalanceLoading ? (
                <>
                  <Skeleton width="100%" height="4rem" className="tw-rounded-lg"></Skeleton>
                  <Skeleton width="100%" height="4rem" className="tw-rounded-lg"></Skeleton>
                </>
              ) : (
                <>
                  {balanceInfo.EndDate && (balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests) && balanceInfo.NumberOfMocktests && (today <= endDate) ? (
                    <>
                      <div className="tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-border tw-border-grey-300 tw-px-2 tw-py-3 tw-bg-white">
                        <div className="mr-2 tw-leading-none">
                          <span className="tw-shadow-none tw-font-semibold">
                            <SvgIcon name="mockTest" size={15} />
                          </span>
                        </div>
                        <div className="tw-flex tw-justify-center tw-items-center ">
                          <small className="tw-text-sm tw-mr-2 tw-font-semibold">Tests Remaining: </small>
                          <h3 className="text-lg tw-font-bold tw-leading-none">{balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests || 0} of {balanceInfo.NumberOfMocktests || 0}</h3>
                        </div>
                      </div>

                      <div className="tw-flex tw-items-center">
                        <span className="tw-flex tw-justify-center tw-align-center tw-gap-2 tw-text-green-600 tw-rounded-lg tw-border tw-border-green-500 tw-px-2 tw-py-3 tw-bg-green-50 tw-w-full">
                          <span className="tw-flex tw-justify-center tw-items-center gap-1 text-sm tw-font-semibold">
                            <SvgIcon name="time" size={15} className="mb-1" />
                            Plan Valid Till:
                          </span>
                          <span className="tw-flex tw-justify-center tw-items-center gap-1 text-lg tw-font-bold">
                            {balanceInfo.EndDate
                              ? moment(balanceInfo.EndDate).format("DD MMM YYYY") : 'N/A'}
                          </span>
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      {balanceInfo.EndDate && (!(balanceInfo.BalanceNumberOfMocktests > 0) || !(balanceInfo.BalanceOfMocktests > 0)) && (today <= endDate) ? (
                        <>
                          <div className="tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-border tw-border-grey-300 tw-px-2 tw-py-3 tw-bg-white">
                            <div className="mr-2 tw-leading-none">
                              <span className="tw-shadow-none tw-font-semibold">
                                <SvgIcon name="mockTest" size={15} />
                              </span>
                            </div>
                            <div className="tw-flex tw-justify-center tw-items-center ">
                              <small className="tw-text-sm tw-mr-2 tw-font-semibold">Tests Remaining:</small>
                              <h3 className="text-xl tw-font-bold tw-leading-none"><span className="text-red-500">{balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests || 0}</span> of {balanceInfo.NumberOfMocktests || 0}</h3>
                            </div>
                          </div>

                          <div className="tw-flex tw-items-center">
                            <span className="tw-flex tw-justify-center tw-align-center tw-gap-2 tw-text-green-600 tw-rounded-lg tw-border tw-border-green-300 tw-px-2 tw-py-3 tw-bg-white tw-w-full">
                              <span className="tw-flex tw-justify-center tw-items-center gap-1 text-sm tw-font-semibold">
                                <SvgIcon name="time" size={15} className="mb-1" />
                                Plan Valid Till:
                              </span>
                              <span className="tw-flex tw-justify-center tw-items-center gap-1 text-lg tw-font-bold">
                                {balanceInfo.EndDate
                                  ? moment(balanceInfo.EndDate).format("DD MMM YYYY") : 'N/A'}
                              </span>
                            </span>
                          </div>
                          {/* <div className="tw-col-span-1 md:tw-col-span-2 mt-2">
                            <span className="tw-text-xs tw-flex tw-items-center tw-gap-1 tw-text-red-500">
                              Maximum Test Limit Reached.
                            </span>
                            {!InstituteId && (
                              <button
                                className="tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt- ia-btn ia-btn-primary"
                                onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                              >
                                Subscribe Now <SvgIcon name="rightArrow" size={16} />
                              </button>
                            )}
                          </div> */}
                          <div className="tw-col-span-1 md:tw-col-span-2 tw-bg-red-200/40 tw-border tw-border-red-200 tw-rounded-lg tw-bg-white tw-px-3 tw-py-3">
                            <div className="lg:tw-flex tw-items-center tw-justify-between tw-gap-2">
                              <span className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-1 tw-text-red-600 tw-mb-3 lg:mb-0">
                                <SvgIcon name="warning" size={24} />
                                Maximum Test Limit Reached.
                              </span>
                              {!InstituteId && (
                                <button
                                  className="tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt- ia-btn ia-btn-primary"
                                  onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                                >
                                  Subscribe Now <SvgIcon name="rightArrow" size={16} />
                                </button>
                              )}
                            </div>

                          </div>
                        </>
                      ) : (
                        <div className="tw-col-span-1 md:tw-col-span-2 tw-bg-red-200/40 tw-border tw-border-red-200 tw-rounded-lg tw-bg-white tw-px-3 tw-py-3">
                          <div className="lg:tw-flex tw-items-center tw-justify-between tw-gap-2">
                            <span className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-1 tw-text-red-600 tw-mb-3 lg:mb-0">
                              <SvgIcon name="warning" size={24} />
                              {InstituteId ? "Currently you don't have any active subscription. Please contact your institute's administrator." : "Currently you don't have any active subscription."}
                            </span>
                            {!InstituteId && (
                              <button
                                className="tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt- ia-btn ia-btn-primary"
                                onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                              >
                                Subscribe Now <SvgIcon name="rightArrow" size={16} />
                              </button>
                            )}
                          </div>

                        </div>
                      )}
                    </>
                  )}
                </>
              )}

            </div>
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-4 ">
              {isPerformanceLoading ? (
                <>
                  <Skeleton width="100%" height="4.5rem" className="tw-rounded-lg"></Skeleton>
                  <Skeleton width="100%" height="4.5rem" className="tw-rounded-lg"></Skeleton>
                  <Skeleton width="100%" height="4.5rem" className="tw-rounded-lg"></Skeleton>
                </>
              ) : (
                <>
                  <div className="custom-card tw-bg-white px-3 py-4">
                    <div className="tw-flex tw-items-center">
                      <div className="mr-2 tw-leading-none">
                        <span className="icon-rounded purple">
                          <SvgIcon name="mockTest" size={20} />
                        </span>
                      </div>
                      <div>
                        <small className="tw-text-xs">Tests Practiced</small>
                        <h3 className="text-xl tw-font-bold tw-leading-none">{statsTotalCount}</h3>
                      </div>
                    </div>
                  </div>

                  <div className="custom-card tw-bg-white px-3 py-4">
                    <div className="tw-flex tw-items-center">
                      <div className="mr-2 tw-leading-none">
                        <span className="icon-rounded purple-light">
                          <SvgIcon name="testCompleted" size={20} />
                        </span>
                      </div>
                      <div>
                        <small className="tw-text-xs">Accuracy</small>
                        {
                          statsTotalCount > 0 ? <h3 className="text-xl tw-font-bold tw-leading-none">{performanceInfo.avgAccuracy ? Number(performanceInfo.avgAccuracy).toFixed(2) : 0}%</h3> : <h3 className="text-xl tw-font-bold tw-leading-none">N/A</h3>
                        }

                      </div>
                    </div>
                  </div>

                  <div className="custom-card tw-bg-white px-3 py-4">
                    <div className="tw-flex tw-items-center">
                      <div className="mr-2 tw-leading-none">
                        <span className="icon-rounded yellow">
                          <SvgIcon name="testPending" size={20} />
                        </span>
                      </div>
                      <div>
                        <small className="tw-text-xs">Average Score</small>
                        {
                          statsTotalCount > 0 ? <h3 className="text-xl tw-font-bold tw-leading-none">{performanceInfo.avgScorePercentage ? Number(performanceInfo.avgScorePercentage).toFixed(2) : 0}/100</h3> : <h3 className="text-xl tw-font-bold tw-leading-none">N/A</h3>
                        }

                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>



            {/* <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 mt-4"> */}
            {/* <div className="custom-card tw-bg-white px-3 py-4">

                {
                  balanceInfo.EndDate && (balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests) && balanceInfo.NumberOfMocktests && (today < endDate) ? <>
                    <div className="tw-flex tw-items-center">
                      <div className="mr-2 tw-leading-none">
                        <span className="icon-rounded green">
                          <SvgIcon name="mockTest" size={20} />
                        </span>
                      </div>
                      <div>
                        <small className="tw-text-xs">Your Test Balance</small>
                        <h3 className="text-xl tw-font-bold tw-leading-none">{balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests || 0} / {balanceInfo.NumberOfMocktests || 0}</h3>
                      </div>
                    </div>

                    <div className="tw-mt-4 ml-1">
                      <span className="tw-text-xs tw-flex tw-items-center tw-gap-1 tw-text-green-600">
                        <SvgIcon name="time" size={15} />
                        Subscription Expires on: {balanceInfo.EndDate
                          ? moment(balanceInfo.EndDate).format("DD-MM-YYYY") : 'N/A'}</span>
                    </div>
                  </> :
                    <>
                      {
                        balanceInfo.EndDate && (!(balanceInfo.BalanceNumberOfMocktests > 0) || !(balanceInfo.BalanceOfMocktests > 0)) && (today < endDate) ?
                          <>
                            <div className="tw-flex tw-items-center">
                              <div className="mr-2 tw-leading-none">
                                <span className="icon-rounded green">
                                  <SvgIcon name="mockTest" size={20} />
                                </span>
                              </div>
                              <div>
                                <small className="tw-text-xs">Your Test Balance</small>
                                <h3 className="text-xl tw-font-bold tw-leading-none"><span className="text-red-500">{balanceInfo.BalanceNumberOfMocktests || balanceInfo.BalanceOfMocktests || 0}</span> / {balanceInfo.NumberOfMocktests || 0}</h3>
                              </div>
                            </div>

                            <div className="tw-mt-4 ml-1">
                              <span className="tw-text-xs tw-flex tw-items-center tw-gap-1 tw-text-green-600">
                                <SvgIcon name="time" size={15} />
                                Subscription Expires on: {balanceInfo.EndDate
                                  ? moment(balanceInfo.EndDate).format("DD-MM-YYYY") : 'N/A'}</span>
                            </div>
                            {
                              <div className="tw-ml-1 mt-2">
                                <span className="tw-text-xs tw-flex tw-items-center tw-gap-1 tw-text-red-500">
                                  Maximum Test Limit Reached.
                                </span>
                                {!InstituteId &&
                                  <button
                                    className="tw-text-[#986efa] tw-text-sm hover:tw-text-[#7a56d9] tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt-5"
                                    onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                                  >
                                    Subscribe Now <SvgIcon name="rightArrow" size={16} />
                                  </button>
                                }
                              </div>
                            }
                          </> :
                          <div className="tw-ml-1">

                            <span className="tw-text-sm tw-flex tw-items-center tw-gap-1 tw-text-grey-600">
                              {
                                InstituteId ? "Currently you don't have any active subscription. Please contact your institute's administrator." : "Currently you don't have any active subscription."
                              }

                            </span>
                            {!InstituteId &&
                              <button
                                className="tw-text-[#986efa] tw-text-sm hover:tw-text-[#7a56d9] tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mt-5"
                                onClick={() => navigate(`${AppRouteURL.SUBSCRIPTION}`)}
                              >
                                Subscribe Now <SvgIcon name="rightArrow" size={16} />
                              </button>
                            }
                          </div>
                      }

                    </>
                }
              </div> */}



            {/* </div> */}





          </div>
          {/* Overall Performance Card */}
          {/* <div className="overall-performance-card">
            <Card title="Overall Performance" className="custom-card tw-relative">
              <Chart type="line" data={lineChartData} options={lineChartOptions} />
            </Card>
          </div> */}

          {/* Activity Hours Chart */}
          <div>
            {/* <Card
              title={
                <div className="tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-4">
                  <span>Practice Hours</span>
                  <Dropdown value={value} setValue={setValue} />
                </div>
              }
              className="custom-card"
            >
              <div style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: '20px',
                gap: '12px'
              }}>
                {chartData?.datasets?.map((ds: any, index: any) => {
                  const isHidden = hiddenDatasets[index] === true;
                  return (
                    <span
                      key={index}
                      onClick={() => toggleDataset(index)}
                      style={{
                        cursor: 'pointer',
                        textDecorationLine: isHidden ? 'line-through' : 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        fontWeight: 600,
                        textDecorationThickness: "2px",
                        fontSize: "13px"
                      }}
                    >
                      <span
                        style={{
                          width: 12,
                          height: 12,
                          backgroundColor: ds.backgroundColor,
                          borderRadius: '50%',
                          marginRight: 6,
                        }}
                      />
                      {ds.label}
                    </span>
                  );
                })}
              </div>

              <div style={{ display: "flex", width: '100%' }}>
                <div style={{ overflowX: 'auto', width: '100%', paddingBottom: '10px' }}>
                  <div style={{ minWidth: (chartData?.labels?.length || 0) * 50 }}>
                    <Chart type="bar" ref={chartRef} data={chartData} options={chartOptions} />
                  </div>
                </div>
              </div>
            </Card> */}
            <div>
              <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 mt-0">
                {isLoading || isPerformanceLoading ? (
                  <>
                    <Skeleton width="100%" height="8rem" className="tw-rounded-lg"></Skeleton>
                    <Skeleton width="100%" height="8rem" className="tw-rounded-lg"></Skeleton>
                  </>
                ) : (
                  <>
                    <div className="custom-card tw-rounded-md tw-border tw-border-blue-500 tw-hover:shadow-lg tw-hover:scale-105 tw-transition-transform  tw-duration-200 tw-bg-blue-50 hover:tw-bg-blue-100 px-3 py-3" style={{ cursor: "pointer" }} onClick={() => navigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.SKILL_ANALYTICS}`)} >
                      <div className="tw-flex tw-items-start tw-justify-between">
                        <div style={{ width: "100%" }} >
                          <div className="tw-text-md tw-text-gray-700 tw-font-semibold">Skill Gaps & Strengths</div>
                          <div className="tw-text-xs tw-font-semibold tw-pr-2 mt-2">Identify your skill gaps and focus on what will improve your score fastest</div>
                        </div>
                        <div className="tw-text-blue-300">
                          <FontAwesomeIcon icon={faArrowTrendUp} style={{ color: "#417cf263", fontSize: "40px" }} />
                        </div>
                      </div>
                      <div className="tw-text-md tw-font-semibold text-right tw-mb-2"> <div className="tw-text-sm tw-text-blue-500 tw-font-semibold text-left mt-3">View Analysis <SvgIcon name="rightArrow" size={12} /> </div></div>
                    </div>

                    <div className="custom-card tw-rounded-md tw-border tw-border-pink-500 tw-hover:shadow-lg tw-hover:scale-105 tw-transition-transform  tw-duration-200 tw-bg-pink-50 hover:tw-bg-pink-100 px-3 py-3" style={{ cursor: "pointer" }} onClick={() => navigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.TOPIC_ANALYTICS}`)} >
                      <div className="tw-flex tw-items-start tw-justify-between">
                        <div style={{ width: "100%" }} >
                          <div className="tw-text-md tw-text-gray-700 tw-font-semibold">Topic-wise Performance</div>
                          <div className="tw-text-xs tw-font-semibold tw-pr-2 mt-2">Pinpoint the exact areas where you lose marks and work on them </div>
                        </div>
                        <div className="tw-text-pink-300">
                          <FontAwesomeIcon icon={faArrowTrendUp} style={{ color: "#da41f263", fontSize: "40px" }} />
                        </div>
                      </div>
                      <div className="tw-text-md tw-font-semibold text-right tw-mb-2"> <div className="tw-text-sm tw-text-pink-500 tw-font-semibold text-left mt-3">View Analysis <SvgIcon name="rightArrow" size={12} /> </div></div>
                    </div>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>


        <div className="tw-grid tw-grid-cols-1 tw-gap-6 mb-4">



          {/* Advisory Test Card */}
          <div>
            {
              isPopularLoading || isLoading || isPerformanceLoading ? (
                <div className="custom-card tw-p-4">
                  <Skeleton width="25%" height="2rem" className="tw-rounded-2xl tw-mb-2 "></Skeleton>
                  <Skeleton width="40%" height="1rem" className="tw-rounded-2xl tw-mb-3"></Skeleton>
                  <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-6" >
                    <Skeleton width="100%" height="15rem" className="tw-rounded-2xl"></Skeleton>
                    <Skeleton width="100%" height="15rem" className="tw-rounded-2xl"></Skeleton>
                    <Skeleton width="100%" height="15rem" className="tw-rounded-2xl"></Skeleton>
                    <Skeleton width="100%" height="15rem" className="tw-rounded-2xl"></Skeleton>
                  </div >
                </div>
              ) :
                <Card title="Get My Personalised Study Plan →" subTitle="Based on your recent performance, here’s what you should practice next" className="custom-card">
                  {
                    popularTests.length > 0 ? (
                      <RecommendedPracticeSlider
                        popularTests={popularTests}
                        checkSubscriptionAndNavigate={checkSubscriptionAndNavigate}
                      />
                    ) : (
                      <div className="tw-col-span-4 tw-text-center tw-py-8">
                        No recommended test available
                      </div>
                    )}
                </Card>

            }

          </div>
        </div>

        {/* Add Banner Section */}
        {/* <div className="mb-4 tw-text-center">
          <img
            src={AddBannerImg}
            alt="dashboard-banner"
            className="tw-rounded-lg mx-auto"
            onError={(e: any) => { e.currentTarget.src = require("@Assets/img/add-banner.jpg"); }}
          />
        </div> */}


        <Card className="custom-card no-padding">
          {isLoading || isPopularLoading || isPerformanceLoading ? (
            <div className="p-4">
              <div className="tw-flex tw-gap-4 mb-4">
                <Skeleton width="8rem" height="2rem" className="tw-rounded-md"></Skeleton>
                <Skeleton width="8rem" height="2rem" className="tw-rounded-md"></Skeleton>
              </div>
              <SkeletonCardDashboardIndex />
            </div>
          ) : (
            dashdetails && (
              <div className="dash-content-card-full-width">
                <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 tw-justify-between tw-items-start lg:tw-items-center tw-px-5 mb-4">
                  <div className="tw-text-2xl tw-font-bold tw-text-black">
                    My Test
                  </div>
                  <div className="tw-flex tw-flex-wrap tw-gap-2 tw-w-full lg:tw-w-auto">
                    <div className="legend-item tw-flex tw-items-center tw-bg-red-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                      <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-poor"></span>{`Score < 30%`}</span>
                    </div>
                    <div className="legend-item tw-flex tw-items-center tw-bg-orange-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                      <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-improving"></span> {`Score 30% - 50%`}</span>
                    </div>
                    <div className="legend-item tw-flex tw-items-center tw-bg-yellow-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                      <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-medium"></span> {"Score 51% - 75%"}</span>
                    </div>
                    <div className="legend-item tw-flex tw-items-center tw-bg-green-100 tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-2 tw-rounded-lg">
                      <span className='tw-font-semibold tw-text-[10px] md:tw-text-sm'><span className="dot dot-good"></span> {"Score > 75%"}</span>
                    </div>
                  </div>

                </div>
                <div className="dashboard-tabs">
                  <ul className="dash-tabs-ul">
                    <li
                      className={`dash-tabs-li ${toggletabs === 1 ? 'active-tab' : ''}`}
                      onClick={() => togglebutton(1)}
                    >
                      Completed Tests
                    </li>
                    <li
                      className={`dash-tabs-li ${toggletabs === 0 ? 'active-tab' : ''}`}
                      onClick={() => togglebutton(0)}
                    >
                      Tests Pending
                    </li>
                  </ul>
                </div>
                {/* Start Table */}
                <div className="dashboard-tabs-content">
                  <div className="table-responsive">
                    {(filteredDashDetails && filteredDashDetails.length) ? (
                      <CardDashboardIndex toggletabs={toggletabs} dashdetails={filteredDashDetails} />
                    ) : (
                      <div className="no-data-section">
                        <img src={NoMocktestSvg} alt="NoMocktestSvg" />
                        <div className="n-d-head">
                          {/* No <span className="n-d-active-span">Mock Tests</span>  added yet! <br /> */}
                          {toggletabs === 1 ? "You haven't completed any test yet!" : "No pending tests available!"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* End Table */}
              </div>
            )
          )}
        </Card>

        {isLoading ? (
          <div className="videotutorials-container">
            <div className="ia-container my-2 lg:my-6">
              <Skeleton width="60%" height="2rem" className="mb-4"></Skeleton>
              <Skeleton width="40%" height="1.2rem" className="mb-6"></Skeleton>
              <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6">
                <Skeleton width="100%" height="15rem" className="tw-rounded-xl"></Skeleton>
                <Skeleton width="100%" height="15rem" className="tw-rounded-xl"></Skeleton>
                <Skeleton width="100%" height="15rem" className="tw-rounded-xl"></Skeleton>
              </div>
            </div>
          </div>
        ) : (
          <VideoTutorials playInPlace={true} usePublicApi={true} />
        )}

      </div>







      <NoSubscriptionDialog
        {...subscriptionDialogProps}
      />
      <Dialog
        visible={pendingTestDialogProps.visible}
        onHide={pendingTestDialogProps.onHide}
        header="Pending Test"
        style={{ width: '420px' }}
        modal
        draggable={false}
        resizable={false}
        closable={true}
      >
        <div className="tw-text-center tw-py-2">
          <p className="tw-text-base tw-mb-1">You have a pending test:</p>
          <p className="tw-font-semibold tw-text-lg tw-mb-4" style={{ color: 'var(--ia-primary)' }}>
            {pendingTestDialogProps.pendingTest?.TestSeriesName}
          </p>
          <p className="tw-text-sm tw-text-gray-500 tw-mb-6">
            Please complete your pending test before starting a new one. For more details, check your test activity on My Test.
          </p>
          <div className="tw-flex tw-justify-center">
            <button
              className="ia-btn ia-btn-primary py-2 px-5"
              onClick={pendingTestDialogProps.onContinue}
            >
              Go To My Test
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};
